import { render } from "./StandardMathQA.vue?vue&type=template&id=5b4e5c8a&scoped=true&ts=true"
import script from "./StandardMathQA.vue?vue&type=script&lang=ts"
export * from "./StandardMathQA.vue?vue&type=script&lang=ts"

import "./StandardMathQA.vue?vue&type=style&index=0&id=5b4e5c8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4e5c8a"]])

export default __exports__